import { UseCase } from '@magicdoor/solid-use-case';
import { companyGateway } from '~/gateways/companyInfoGateway';
import { MainAppState, mainAppState } from '../state/mainAppState';

export abstract class MagicUseCase extends UseCase<MainAppState> {
  protected isAppStateInitialized = () => {
    return !!this.getState() && !!this.getState()?.user.companyInfo;
  };

  protected async initializeState(): Promise<MainAppState> {
    const domain = this.getState()?.user.domain;
    if (domain && !this.getState()?.user.companyInfo) {
      this.getState().user.companyInfo = await companyGateway.getCompanyInfo(domain);
    }
    return mainAppState;
  }
}
